import { MyAccountContent, useMyAccountResourcesContent } from '@vp/my-account-pages-dropdown'
import { Box, Button, Divider, FlexBox, H2 } from '@vp/swan'
import { useMemo } from 'react'
import { useAuth } from '../../../hooks/useAuth'
import { useI18n } from '../../../context/TranslationContext'

const createMyAccountHeader = (profile: MyAccountUserPopProps['profile']) => () => {
  const { content } = useMyAccountResourcesContent()
  if (!content) return null

  return (
    <Box style={{ width: '250px' }}>
      <H2 fontSkin="body-standard" mb={0}>
        {content.signedIn.header.text} {profile?.['firstName'] ?? ''}
      </H2>
    </Box>
  )
}

const createMyAccountFooter = () => () => {
  const { signOut } = useAuth()
  const { content } = useMyAccountResourcesContent()
  const { translate } = useI18n()
  const signOutText = content?.signedIn.footer.signOutButtonText ?? translate('signOut')

  return (
    <>
      <Divider />
      <FlexBox justifyContent="center">
        <Button id="my-account-logout-btn" my={3} onClick={signOut}>
          {signOutText}
        </Button>
      </FlexBox>
    </>
  )
}

type MyAccountUserPopProps = {
  profile: Record<string, string | undefined> | undefined
  placement?: 'sidebar'
}

export const MyAccountUserPop: React.FC<MyAccountUserPopProps> = ({ profile, placement }) => {
  const Header = useMemo(() => createMyAccountHeader(profile), [profile])
  const Footer = useMemo(() => createMyAccountFooter(), [])

  return (
    <MyAccountContent
      mode={placement === 'sidebar' ? 'sidebar' : 'dropdown'}
      header={placement === 'sidebar' ? undefined : Header}
      footer={placement === 'sidebar' ? undefined : Footer}
    />
  )
}
